import store from "../store"
import chatRoute from "./chat"
import internshipRoute from "./internship"
import masterRoute from "./master"
import transcriptRoute from "./transcript"
import thesisRoute from "./thesis"
import pptaRoute from "./pptaRoute"
import letterRoute from "./letter"
import localForage from 'localforage';
import seminarRoute from './seminar'
import asistenDosenRoute from './asisten'
import kewir from './kampus-merdeka/kewir'
import proyekKemanusiaan from './kampus-merdeka/proyek-kemanusiaan'
import kampusMengajar from './kampus-merdeka/kampus-mengajar'
import kknTematik from './kampus-merdeka/kkn-tematik'
import institution from './kampus-merdeka/institution'
import pertukaranpel from './kampus-merdeka/pertukaranpel'
import studiindependen from './kampus-merdeka/studiindependen'
import penelitian from './kampus-merdeka/penelitian'
import studioRoute from './studio'
import portfolioRoute from './portfolio'
import tapiRoute from './tapiRoute'

function loadDashboard(view) {
    return () => import( /* webpackChunkName: "dashboard-[request]" */ `../components/dashboard/${view}.vue`)
}
function loadGuidance(view) {
    return () => import( /* webpackChunkName: "guidances-[request]" */ `../components/Guidances/${view}.vue`)
}
function loadUser(view) {
    return () => import( /* webpackChunkName: "user-[request]" */ `../components/User/${view}.vue`)
}
function loadAdvisor(view) {
    return () => import( /* webpackChunkName: "advisor-[request]" */ `../components/Advisor/${view}.vue`)
}
function loadReport(view) {
    return () => import( /* webpackChunkName: "report-[request]" */ `../components/report/${view}.vue`)
}
  
const routes = [
    ...chatRoute,
    ...internshipRoute,
    ...masterRoute,
    ...transcriptRoute,
    ...thesisRoute,
    ...letterRoute,
    ...seminarRoute,
    ...pptaRoute,
    ...asistenDosenRoute,
    ...kewir,
    ...proyekKemanusiaan,
    ...kampusMengajar,
    ...kknTematik,
    ...institution,
    ...pertukaranpel,
    ...studiindependen,
    ...penelitian,
    ...studioRoute,
    ...portfolioRoute,
    ...tapiRoute,
    {
      path: '/',
      name: 'Dashboard',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadDashboard('Dashboard')
    },
    {
      path: '/announcement',
      name: 'Announcement Form',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['superadmin','administrator','wadek','kaprodi','sekprodi']
      },
      component: loadDashboard('AnnouncementForm')
    },
    {
      path: '/announcement/:id',
      name: 'Announcement Edit',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['superadmin','administrator','wadek','kaprodi','sekprodi']
      },
      component: loadDashboard('AnnouncementForm')
    },
    {
      path: '/info/:slug',
      name: 'Announcement Detail',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadDashboard('AnnouncementDetail')
    },
    {
      path: '/dosen/bimbingan/:type',
      name: 'MyGuidanceStudents',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['dosen','kadep','kaprodi','wadek','sekprodi','kalab']
      },
      component: loadGuidance('ListMahasiswaBimbingan')
    },
    {
      path: '/dosen/bimbingan/:type/:student_id',
      name: 'MyStudentGuidances',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['dosen','kadep','kaprodi','wadek','sekprodi','kalab']
      },
      component: loadGuidance('ListBimbinganMahasiswa')
    },
    {
      path: '/dosen/bimbinganKRS/:student_id',
      name: 'MyStudentKRSGuidances',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['dosen','kadep','kaprodi','wadek','sekprodi','kalab']
      },
      component: loadGuidance('ListBimbinganKRSMahasiswa')
    },
    {
      path: '/dosen/bimbingan/:type/:student_id/:guidance_id',
      name: 'ResponseMyStudentGuidance',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['dosen','kadep','kaprodi','wadek','sekprodi','kalab']
      },
      component: loadGuidance('ReponseBimbinganMahasiswa')
    },
    {
      path: '/mahasiswa/bimbingan/:type/:guidance_id',
      name: 'ResponseGuidance',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
      },
      component: loadGuidance('ReponseBimbinganMahasiswa')
    },
    {
      path: '/mahasiswa/bimbinganKRS',
      name: 'Bimbingan KRS',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
      },
      component: loadGuidance('ListBimbinganKRS')
    },
    {
      path: '/form/bimbinganKRS/:type',
      name: 'Form Bimbingan KRS',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
      },
      component: loadGuidance('FormBimbinganKRS')
    },
    {
      path: '/form/bimbinganKRS/:type/:guidance_id',
      name: 'Form Bimbingan KRS Edit',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
      },
      component: loadGuidance('FormBimbinganKRS')
    },
    {
      path: '/mahasiswa/bimbinganKRS/:guidance_id',
      name: 'Detail Bimbingan KRS',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
      },
      component: loadGuidance('DetailBimbinganKRS')
    },
    {
      path: '/dosen/bimbinganKRS/:student_id/:guidance_id',
      name: 'Detail Bimbingan KRS Mahasiswa',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['dosen','kadep','kaprodi','wadek','sekprodi','kalab']
      },
      component: loadGuidance('DetailBimbinganKRS')
    },
    {
      path: '/mahasiswa/bimbingan/:type',
      name: 'List Bimbingan',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
      },
      component: loadGuidance('ListBimbingan')
    },
    {
      path: '/mahasiswa/detail/:type/:id',
      name: 'Detail Bimbingan',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
      },
      component: loadGuidance('DetailBimbingan')
    },
    {
      path: '/form/bimbingan/:type',
      name: 'Form Bimbingan',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
      },
      component: loadGuidance('FormBimbingan')
    },
    {
      path: '/kaprodi',
      name: 'Kaprodi',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
      },
      component: loadUser('Kaprodi')
    },
    {
      path: '/kalab',
      name: 'Kalab',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
      },
      component: loadUser('Kalab')
    },
    {
      path: '/wadek',
      name: 'Wadek',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
      },
      component: loadUser('Wadek')
    },
    {
      path: '/kadep',
      name: 'Kadep',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
      },
      component: loadUser('Kadep')
    },
    {
      path: '/mahasiswa',
      name: 'Mahasiswa',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator','kaprodi', 'sekprodi','kadep']
      },
      component: loadUser('Mahasiswa')
    },
    {
      path: '/dosen',
      name: 'Dosen',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator','kaprodi', 'sekprodi','kadep']
      },
      component: loadUser('Dosen')
    },
    {
      path: '/laboran',
      name: 'Laboran',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
      },
      component: loadUser('Laboran')
    },
    {
      path: '/dosen/:id/akademik',
      name: 'Mahasiswa Bimbingan Akademik',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi', 'sekprodi']
      },
      component: loadAdvisor('Akademik')
    },
    {
      path: '/report/dokumen',
      name: 'Dokumen Report',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
      },
      component: loadReport('DokumenReport')
    },
    {
      path: '/report/dokumen/faculty',
      name: 'Dokumen Report Faculty',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
      },
      component: loadReport('LectureReportFaculty')
    },
    {
      path: '/report/graphic',
      name: 'Graphic Report',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi','wadek','dosen','kadep','kalab']
      },
      component: loadReport('GraphicReport')
    },

    // Advisor
    {
      path: '/advisor/:type',
      name: 'List Pembimbing',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
      },
      component: loadAdvisor('ListMahasiswa')
    },
    // Advisor
    // Dashboard
    {
      path: '/lectureQuota',
      name: 'LectureQuota',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi','wadek']
      },
      component: loadDashboard('LectureQuota')
    },
    {
      path: '/lecturePPTAandTA',
      name: 'LecturePPTAandTA',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi','wadek']
      },
      component: loadDashboard('LecturePPTAandTA')
    },
    {
      path: '/lectureRequestTA',
      name: 'lectureRequestTA',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi','wadek']
      },
      component: loadDashboard('LectureRequestTA')
    },
    {
      path: '/studentsAnalytic',
      name: 'StudentsAnalytic',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi','wadek']
      },
      component: loadDashboard('StudentsAnalytic')
    },
    {
      path: '/rekapanprakrs',
      name: 'PraKRSResult',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
      },
      component: loadDashboard('PraKRSResult')
    },
    {
      path: '/rekapankrs',
      name: 'KRSResult',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
      },
      component: loadDashboard('KRSResult')
    },
    {
      path: '/profile',
      name: 'profile',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadUser('Profile')
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadUser('ChangePassword')
    },
    // Dashboard
    {
      path: '/login',
      name: 'Login',
      meta: {
          requiresAuth: false,
          beforelogin: true,
          roleVerif: false,
          role: []
      },
      component: () => import( /* webpackChunkName: "component-login" */ `../views/Login.vue`)
    },
    {
      path: '/logout',
      name: 'logoutComponent',
      meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
      },
      component: () => import( /* webpackChunkName: "component-logout" */ `../views/Logout.vue`)
    },
    // superadmin
    {
      path: '/administrator',
      name: 'Administrator',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['superadmin']
      },
      component: loadUser('Administrator')
    },
    // superadmin
    {
      path: '*',
      name: 'NotFound',
      meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
      },
      component: () => import( /* webpackChunkName: "component-notfound" */ `../views/NotFound.vue`)
    },
    
  ]
const routerFilter = async (routes) => {
  await store.restored;
  const temp = await localForage.getItem("BimbinganUAJY")
  let myrole = null
  if(temp){
    myrole = temp.auth.user.role
  }
  const isLoggedIn = store.getters['getisLoggedIn']
  return routes.filter((row) => {
    return (row.meta.requiresAuth == isLoggedIn && ((row.meta.roleVerif && row.meta.role.some(role => role == myrole) || !row.meta.roleVerif))) || !row.meta.requiresAuth
  })

}
export default routerFilter(routes)